import { Component, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { DataType } from '@miq/catalog';
import { AbstractAdvancedInput } from '../abstract-advanced-input';

@Component({
  template: `
    <span class="brokers-number-checkbox">
      <mat-checkbox
        [required]="configuration.required"
        [(ngModel)]="checked"
        (change)="changed($event)"
        [disabled]="configuration.isDisabled"
      ></mat-checkbox>
    </span>
  `,
  standalone: false,
})
export class AdvancedCheckboxInputComponent extends AbstractAdvancedInput implements OnInit {
  public checked = false;
  private trueValue: boolean | string | number = true;
  private falseValue: boolean | string | number = false;

  ngOnInit() {
    this.setTrueFalseValuesBasedOnType();
    this.checked = this.value === this.trueValue;
  }

  public changed(params: MatCheckboxChange) {
    this.value = params.checked ? this.trueValue : this.falseValue;
  }

  private setTrueFalseValuesBasedOnType() {
    switch (this.configuration.dataType) {
      case DataType.Boolean:
        this.trueValue = true;
        this.falseValue = false;
        break;
      case DataType.Numeric:
      case DataType.Integer:
        this.trueValue = 1;
        this.falseValue = 0;
        break;
      case DataType.Text:
        this.trueValue = 'Y';
        this.falseValue = 'N';
        break;
    }
  }
}
